export default __webpack_public_path__ + "static/background-watercolor-267447bb698e7ca14281b64decde3c30.png";